import React, { type JSX } from 'react';
import { useHistory, useRouteMatch } from 'react-router';
import { HydratedStoryPoint } from 'magical-trails';

import TrailPointItem from './TrailPointItem';

import './styles/index.scss';

export interface Props {
  points: HydratedStoryPoint[];
  onSelect: (pointId: string) => void;
  selectedPoint: string;
  showDirections?: boolean;
  scrollSnapEnabled: boolean;
  pauseScrollSnap: () => void;
}

const TrailPoints: React.FC<Props> = ({
  points,
  onSelect,
  selectedPoint,
  showDirections,
  scrollSnapEnabled,
  pauseScrollSnap,
}: Props): JSX.Element => {
  let { url } = useRouteMatch();
  let history = useHistory();
  let locationCount = 0;
  return (
    <ul
      className={`TrailPoints ${
        scrollSnapEnabled ? 'TrailPoints_scrollSnapEnabled' : ''
      } `}
      onScroll={pauseScrollSnap}
    >
      {points.map((point, index): JSX.Element => {
        // A stop the author has removed keeps its place in the list but not
        // its number: the numbering labels untitled locations by their
        // position on the trail as it stands now.
        if (point.type === 'location' && !point.removedFromTrail) {
          locationCount++;
        }
        return (
          <TrailPointItem
            key={point.code}
            point={point}
            onSelect={() => {
              onSelect(point.code || '');
            }}
            selectedPoint={selectedPoint}
            openDirections={() => {
              history.push(`${url}/directions/${point.code}`);
            }}
            openTrailPointPage={() => {
              history.push(`${url}/trail-point/${point.code}`);
            }}
            locationNumber={
              point.type === 'location' ? locationCount : undefined
            }
            showDirections={showDirections}
          />
        );
      })}
    </ul>
  );
};

export default TrailPoints;
